import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CarePlanService } from 'src/app/services/carePlan.service';

@Component({
  selector: 'app-health-care-plan-section',
  templateUrl: './health-care-plan-section.component.html',
  styleUrls: ['./health-care-plan-section.component.css'],
  standalone: false,
})
export class HealthCarePlanSectionComponent {
  private destroy$ = new Subject<void>();

  addScreen = false;

  constructor(private readonly carePlanService: CarePlanService) {}

  ngOnInit() {
    this.carePlanService.carePlanModalSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.addScreen = data;
      });
  }

  ngOnDestroy() {
    this.carePlanService.resetEditorState();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
